<template>
  <div>
    <table v-if="item.chapter_markers && item.chapter_markers.length" v-perms="['chapters']" class="table table-striped">
      <thead>
        <tr>
          <th scope="col">
            Name
          </th>
          <th scope="col">
            Time Stamp
          </th>
          <th scope="col">
            Enabled
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(marker, index) in item.chapter_markers" :key="index">
          <td v-if="!marker.is_ad">
            {{ marker.name }}
          </td>
          <td v-else>
            Ad
          </td>
          <td>{{ formatTime(marker.time) }}</td>
          <td v-if="marker.enabled">
            Yes
          </td>
          <td v-else>
            No
          </td>
        </tr>
      </tbody>
    </table>
    <div v-else>
      <strong>No Chapter Markers</strong>
    </div>
    <div>
      <div class="text-md-right">
        <a :href="`/chapter-markers/${item.uuid}/edit`" target="_blank" class="btn btn-ss">Edit Chapters</a>
      </div>
    </div>
  </div>
</template>

<script>
import { convertToHhmmss } from "Helpers/formatters";

export default {
  components: {},
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {},
  methods: {
    formatTime(value) {
      return convertToHhmmss(value);
    },
  },
};
</script>
